import React from "react";
import { pick, pipe } from "ramda";
import { Transformation } from "cloudinary-react";
import { Link } from "react-router-dom";
import encodeBase64String from "../../lib/encodeBase64String";

import * as UI from "./ui";

const ThankYouCampaign = ({ campaign }) => (
  <Link to={`/?promo=${campaign.promoCode.name}`}>
    <UI.SmallThankYouCampaignImage src={campaign.smallImageUrl} />
    <UI.LargeThankYouCampaignImage src={campaign.largeImageUrl} />
  </Link>
);

const buildDonorParam = pipe(
  pick(["firstName", "lastName", "email", "phoneNumber"]),
  JSON.stringify,
  encodeBase64String,
);

const SponsorCampaign = ({ campaign, donor }) => (
  <a target="_blank" rel="noreferrer" href={`${campaign.url}?donor=${buildDonorParam(donor)}`}>
    <UI.SmallSponsorCampaignImage {...campaign.smallImage} fetchFormat="auto">
      <Transformation width="480" height="320" crop="auto" gravity="auto" />
    </UI.SmallSponsorCampaignImage>
    <UI.LargeSponsorCampaignImage {...campaign.largeImage} fetchFormat="auto">
      <Transformation width="970" height="250" crop="auto" gravity="auto" />
    </UI.LargeSponsorCampaignImage>
  </a>
);

const LoyaltyCampaign = ({ sweepstakes, donor }) => {
  const { activeThankYouCampaign, activeSponsorCampaign } = sweepstakes;

  if (!activeThankYouCampaign && !activeSponsorCampaign) {
    return null;
  } 

  return activeSponsorCampaign ? (
    <SponsorCampaign campaign={activeSponsorCampaign} donor={donor} />
  ) : (
    <ThankYouCampaign campaign={activeThankYouCampaign} />
  );
};

export default LoyaltyCampaign;
